import { Button, Chip, IconButton, Stack, styled } from '@mui/material';

import { colors } from '@/theme/variables';

export const RelatedRecordRowRoot = styled(Stack)(() => ({
  padding: '10px 88px 10px 12px',
  width: '100%',
  marginBottom: 10,
  borderRadius: 8,
  boxShadow: '0px 0px 0px 1px #E7EAEC',
  position: 'relative',
  flexDirection: 'row',
  alignItems: 'center',
  '&:hover .MuiButton-root': {
    display: 'inline-flex',
  },
}));

export const RecordTypePill = styled(Chip)(() => ({
  height: 22,
  fontSize: 11,
  fontWeight: 600,
  borderRadius: 4,
  marginRight: 10,
  flexShrink: 0,
}));

export const RelateRecordDelete = styled(Button)(() => ({
  color: colors.error.main,
  padding: 0,
  minWidth: 0,
  display: 'none',
  position: 'absolute',
  right: 44,
  top: '50%',
  transform: 'translateY(-50%)',
}));

export const RelateRecordIconButton = styled(IconButton)(() => ({
  color: colors.grey[60],
  padding: 4,
  position: 'absolute',
  right: 8,
  top: '50%',
  transform: 'translateY(-50%)',
}));
